// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__NXFJZ","error":"Textarea_error__3z5V8","readonly":"Textarea_readonly__2pmKC","disabled":"Textarea_disabled__2Q6zX"};